<div class="d-flex align-items-center w-100 justify-content-center" *ngIf="message">
  <p-message severity="warn" [text]="message"></p-message>
</div>
<pagebuilder
  [environment]="environment"
  [permission]="permission"
  [commonService]="commonService"
  [inputValidationMethod]="inputValidationMethod"
  (pageEnter)="onPageEnter($event)"
  (pageExit)="onPageLeave($event)"
></pagebuilder>
